import React from 'react'
import { Route } from 'react-router-dom'
import { RecordRoute } from '../../../../shared/page/record-route'
import { LoginList } from './page/login-list'
import { LoginEdit } from './page/login-edit'
import { Delete } from '../../../../shared/page/page-delete'
import { Purge } from '../../../../shared/page/page-purge'
import { LoginRecycle } from './page/login-recycle'
import { LoginAdd } from './page/login-add'
import { OrganizationUserEdit } from './page/organization/organization-user-edit'
import { OrganizationUserAdd } from './page/organization/organization-user-add'
import { useApiFormLogin, useApiFormLoginUser } from '../../../../api-new/state/content'
import { OrganizationUserList } from './page/organization/organization-user-list'
import { LoginImpersonateSSO } from './page/login-impersonate-sso'
import { sysMembershipLinks, sysOrganizationLinks } from '../../../../shared/error/last-owner-links'

export const LayoutLogin = () => {
  return (
    <React.Fragment>
      <Route path="/admin/login/list" component={LoginList} />
      <Route path="/admin/login/list/add" component={LoginAdd} />
      <RecordRoute path="/admin/login/list/edit/:loginID" component={LoginEdit} />
      <RecordRoute path="/admin/login/list/edit/:deleteID/delete">
        <Delete useApiForm={useApiFormLogin} titleParam="email" successPath="/admin/login/list" lastOwnerLinks={sysOrganizationLinks} />
      </RecordRoute>

      <Route path="/admin/login/list/edit/:loginID/impersonate-sso" component={LoginImpersonateSSO} />

      <Route path="/admin/login/list/recycle" component={LoginRecycle} />
      <RecordRoute path="/admin/login/list/recycle/purge/:purgeID">
        <Purge useApiForm={useApiFormLogin} titleParam="email" successPath="/admin/login/list/recycle" showServerError lastOwnerLinks={sysOrganizationLinks} />
      </RecordRoute>

      <Route path="/admin/login/list/edit/:loginID/organizations" component={OrganizationUserList} />
      <RecordRoute path="/admin/login/list/edit/:loginID/organizations/edit/:userID" component={OrganizationUserEdit} />
      <Route path="/admin/login/list/edit/:loginID/organizations/add" component={OrganizationUserAdd} />

      {/* Removing a membership is a soft delete (DELETE /login-user/:id), refused
          with 409 organization.last_owner for the organization's last owner. */}
      <RecordRoute path="/admin/login/list/edit/:loginID/organizations/edit/:userID/delete/:deleteID">
        <Delete
          useApiForm={useApiFormLoginUser}
          titleParam="organizationName"
          successPath="/admin/login/list/edit/:loginID/organizations"
          lastOwnerLinks={sysMembershipLinks}
        />
      </RecordRoute>
      {/* Purge takes only a removed membership (content: recycle bin only). */}
      <RecordRoute path="/admin/login/list/edit/:loginID/organizations/edit/:userID/purge/:purgeID">
        <Purge useApiForm={useApiFormLoginUser} titleParam="organizationName" successPath="/admin/login/list/edit/:loginID/organizations" showServerError />
      </RecordRoute>
    </React.Fragment>
  )
}
